module.exports = __webpack_public_path__ + "static/media/HubertMittermayerNesterovskiy.874f753b.jpg";